var map = {
	"./banjo-and-kazooie/full0-min.png": "d43c",
	"./banjo-and-kazooie/full1-min.png": "8620",
	"./banjo-and-kazooie/full2-min.png": "6d72",
	"./banjo-and-kazooie/full3-min.png": "65cd",
	"./banjo-and-kazooie/full4-min.png": "6f53",
	"./banjo-and-kazooie/full5-min.png": "718e",
	"./banjo-and-kazooie/full6-min.png": "6144",
	"./banjo-and-kazooie/full7-min.png": "21d8",
	"./banjo-and-kazooie/selected0-min.png": "8db3",
	"./banjo-and-kazooie/selected1-min.png": "0d11",
	"./banjo-and-kazooie/selected2-min.png": "ae35",
	"./banjo-and-kazooie/selected3-min.png": "967e",
	"./banjo-and-kazooie/selected4-min.png": "5494",
	"./banjo-and-kazooie/selected5-min.png": "4ba1",
	"./banjo-and-kazooie/selected6-min.png": "7954",
	"./banjo-and-kazooie/selected7-min.png": "14ba",
	"./bayonetta/full0-min.png": "1dac",
	"./bayonetta/full1-min.png": "9adb",
	"./bayonetta/full2-min.png": "9ee0",
	"./bayonetta/full3-min.png": "e607",
	"./bayonetta/full4-min.png": "5349",
	"./bayonetta/full5-min.png": "889b",
	"./bayonetta/full6-min.png": "136c",
	"./bayonetta/full7-min.png": "f9f2",
	"./bayonetta/selected0-min.png": "db9e",
	"./bayonetta/selected1-min.png": "8350",
	"./bayonetta/selected2-min.png": "6915",
	"./bayonetta/selected3-min.png": "290c",
	"./bayonetta/selected4-min.png": "2c7d",
	"./bayonetta/selected5-min.png": "1271",
	"./bayonetta/selected6-min.png": "ee06",
	"./bayonetta/selected7-min.png": "d464",
	"./bowser-jr/full0-min.png": "ecfc",
	"./bowser-jr/full1-min.png": "101a",
	"./bowser-jr/full2-min.png": "8111",
	"./bowser-jr/full3-min.png": "aff5",
	"./bowser-jr/full4-min.png": "a61b",
	"./bowser-jr/full5-min.png": "843f",
	"./bowser-jr/full6-min.png": "8e31",
	"./bowser-jr/full7-min.png": "f18b",
	"./bowser-jr/selected0-min.png": "1ebd",
	"./bowser-jr/selected1-min.png": "ad69",
	"./bowser-jr/selected2-min.png": "6f16",
	"./bowser-jr/selected3-min.png": "b6c2",
	"./bowser-jr/selected4-min.png": "f146",
	"./bowser-jr/selected5-min.png": "8844",
	"./bowser-jr/selected6-min.png": "8a31",
	"./bowser-jr/selected7-min.png": "f4fc",
	"./bowser/full0-min.png": "6f94",
	"./bowser/full1-min.png": "c700",
	"./bowser/full2-min.png": "000e",
	"./bowser/full3-min.png": "4809",
	"./bowser/full4-min.png": "67cf",
	"./bowser/full5-min.png": "ea86",
	"./bowser/full6-min.png": "e9cc",
	"./bowser/full7-min.png": "6a01",
	"./bowser/selected0-min.png": "9a55",
	"./bowser/selected1-min.png": "b413",
	"./bowser/selected2-min.png": "36b9",
	"./bowser/selected3-min.png": "4afb",
	"./bowser/selected4-min.png": "3807",
	"./bowser/selected5-min.png": "bf27",
	"./bowser/selected6-min.png": "d30c",
	"./bowser/selected7-min.png": "a8c0",
	"./byleth/full0-min.png": "6efd",
	"./byleth/full1-min.png": "777f",
	"./byleth/full2-min.png": "39b8",
	"./byleth/full3-min.png": "37e6",
	"./byleth/full4-min.png": "c1f2",
	"./byleth/full5-min.png": "94c4",
	"./byleth/full6-min.png": "4d1a",
	"./byleth/full7-min.png": "0773",
	"./byleth/selected0-min.png": "7570",
	"./byleth/selected1-min.png": "4db5",
	"./byleth/selected2-min.png": "fd00",
	"./byleth/selected3-min.png": "f6d9",
	"./byleth/selected4-min.png": "8ecb",
	"./byleth/selected5-min.png": "3b2d",
	"./byleth/selected6-min.png": "7b39",
	"./byleth/selected7-min.png": "532a",
	"./captain-falcon/full0-min.png": "4239",
	"./captain-falcon/full1-min.png": "eb44",
	"./captain-falcon/full2-min.png": "e1aa",
	"./captain-falcon/full3-min.png": "6bcc",
	"./captain-falcon/full4-min.png": "b1a4",
	"./captain-falcon/full5-min.png": "41ca",
	"./captain-falcon/full6-min.png": "8a31c",
	"./captain-falcon/full7-min.png": "03e3",
	"./captain-falcon/selected0-min.png": "d38a",
	"./captain-falcon/selected1-min.png": "9476",
	"./captain-falcon/selected2-min.png": "3662",
	"./captain-falcon/selected3-min.png": "bd07",
	"./captain-falcon/selected4-min.png": "0d92",
	"./captain-falcon/selected5-min.png": "59e6",
	"./captain-falcon/selected6-min.png": "cdea",
	"./captain-falcon/selected7-min.png": "1183",
	"./chrom/full0-min.png": "4741",
	"./chrom/full1-min.png": "1e9b",
	"./chrom/full2-min.png": "53ab",
	"./chrom/full3-min.png": "ada6",
	"./chrom/full4-min.png": "63d9",
	"./chrom/full5-min.png": "a2eb",
	"./chrom/full6-min.png": "279d",
	"./chrom/full7-min.png": "c9ca",
	"./chrom/selected0-min.png": "53cb",
	"./chrom/selected1-min.png": "e013",
	"./chrom/selected2-min.png": "ff2a",
	"./chrom/selected3-min.png": "800f",
	"./chrom/selected4-min.png": "1ad0",
	"./chrom/selected5-min.png": "df6d",
	"./chrom/selected6-min.png": "59e9",
	"./chrom/selected7-min.png": "f571",
	"./cloud/full0-min.png": "637d",
	"./cloud/full1-min.png": "70f4",
	"./cloud/full2-min.png": "9e61",
	"./cloud/full3-min.png": "0fe5",
	"./cloud/full4-min.png": "cbb7",
	"./cloud/full5-min.png": "5b64",
	"./cloud/full6-min.png": "0bc6",
	"./cloud/full7-min.png": "5531",
	"./cloud/selected0-min.png": "45a5",
	"./cloud/selected1-min.png": "c38a",
	"./cloud/selected2-min.png": "5d02",
	"./cloud/selected3-min.png": "f0c0",
	"./cloud/selected4-min.png": "74df",
	"./cloud/selected5-min.png": "66f7",
	"./cloud/selected6-min.png": "e253",
	"./cloud/selected7-min.png": "952f",
	"./corrin/full0-min.png": "3873",
	"./corrin/full1-min.png": "e11e",
	"./corrin/full2-min.png": "1190",
	"./corrin/full3-min.png": "71fa",
	"./corrin/full4-min.png": "c577",
	"./corrin/full5-min.png": "86d4",
	"./corrin/full6-min.png": "898e",
	"./corrin/full7-min.png": "5c63",
	"./corrin/selected0-min.png": "5f55",
	"./corrin/selected1-min.png": "086c",
	"./corrin/selected2-min.png": "d9c2",
	"./corrin/selected3-min.png": "6db6",
	"./corrin/selected4-min.png": "ee81",
	"./corrin/selected5-min.png": "ec10",
	"./corrin/selected6-min.png": "c0fa",
	"./corrin/selected7-min.png": "6183",
	"./daisy/full0-min.png": "c61f",
	"./daisy/full1-min.png": "2dac",
	"./daisy/full2-min.png": "5e29",
	"./daisy/full3-min.png": "5770",
	"./daisy/full4-min.png": "5c43",
	"./daisy/full5-min.png": "12a0",
	"./daisy/full6-min.png": "1b06",
	"./daisy/full7-min.png": "87a1",
	"./daisy/selected0-min.png": "0122",
	"./daisy/selected1-min.png": "491e",
	"./daisy/selected2-min.png": "285f",
	"./daisy/selected3-min.png": "659a",
	"./daisy/selected4-min.png": "cfed",
	"./daisy/selected5-min.png": "8e35",
	"./daisy/selected6-min.png": "8b98",
	"./daisy/selected7-min.png": "ae06",
	"./dark-pit/full0-min.png": "5df0",
	"./dark-pit/full1-min.png": "db91",
	"./dark-pit/full2-min.png": "e651",
	"./dark-pit/full3-min.png": "0e06",
	"./dark-pit/full4-min.png": "252c",
	"./dark-pit/full5-min.png": "4477",
	"./dark-pit/full6-min.png": "4775",
	"./dark-pit/full7-min.png": "b886",
	"./dark-pit/selected0-min.png": "1e4f",
	"./dark-pit/selected1-min.png": "b39c",
	"./dark-pit/selected2-min.png": "345d",
	"./dark-pit/selected3-min.png": "7112",
	"./dark-pit/selected4-min.png": "00ec",
	"./dark-pit/selected5-min.png": "ca02",
	"./dark-pit/selected6-min.png": "c2bf",
	"./dark-pit/selected7-min.png": "ffb8",
	"./dark-samus/full0-min.png": "73e2",
	"./dark-samus/full1-min.png": "a6e5",
	"./dark-samus/full2-min.png": "4b3e",
	"./dark-samus/full3-min.png": "5229",
	"./dark-samus/full4-min.png": "f696",
	"./dark-samus/full5-min.png": "7530",
	"./dark-samus/full6-min.png": "dcd6",
	"./dark-samus/full7-min.png": "cba9",
	"./dark-samus/selected0-min.png": "bbd7",
	"./dark-samus/selected1-min.png": "e8bb",
	"./dark-samus/selected2-min.png": "f42b",
	"./dark-samus/selected3-min.png": "e125",
	"./dark-samus/selected4-min.png": "4232",
	"./dark-samus/selected5-min.png": "301e",
	"./dark-samus/selected6-min.png": "0201",
	"./dark-samus/selected7-min.png": "cf88",
	"./diddy-kong/full0-min.png": "877d",
	"./diddy-kong/full1-min.png": "81e4",
	"./diddy-kong/full2-min.png": "6c90",
	"./diddy-kong/full3-min.png": "cff2",
	"./diddy-kong/full4-min.png": "018d",
	"./diddy-kong/full5-min.png": "dd3c",
	"./diddy-kong/full6-min.png": "2b1e",
	"./diddy-kong/full7-min.png": "02ba",
	"./diddy-kong/selected0-min.png": "d7e1",
	"./diddy-kong/selected1-min.png": "9c40",
	"./diddy-kong/selected2-min.png": "9be3",
	"./diddy-kong/selected3-min.png": "d8fe",
	"./diddy-kong/selected4-min.png": "7d82",
	"./diddy-kong/selected5-min.png": "a8f3",
	"./diddy-kong/selected6-min.png": "2dbd",
	"./diddy-kong/selected7-min.png": "b986",
	"./donkey-kong/full0-min.png": "57c3",
	"./donkey-kong/full1-min.png": "2633",
	"./donkey-kong/full2-min.png": "d9eb",
	"./donkey-kong/full3-min.png": "846b",
	"./donkey-kong/full4-min.png": "be25",
	"./donkey-kong/full5-min.png": "e919",
	"./donkey-kong/full6-min.png": "2c1e",
	"./donkey-kong/full7-min.png": "e571",
	"./donkey-kong/selected0-min.png": "3088",
	"./donkey-kong/selected1-min.png": "1bf7",
	"./donkey-kong/selected2-min.png": "b649",
	"./donkey-kong/selected3-min.png": "e1fa",
	"./donkey-kong/selected4-min.png": "236b",
	"./donkey-kong/selected5-min.png": "cadc",
	"./donkey-kong/selected6-min.png": "0fdd",
	"./donkey-kong/selected7-min.png": "a5e6",
	"./dr-mario/full0-min.png": "2622",
	"./dr-mario/full1-min.png": "a26c",
	"./dr-mario/full2-min.png": "f7d9",
	"./dr-mario/full3-min.png": "b0de",
	"./dr-mario/full4-min.png": "1885",
	"./dr-mario/full5-min.png": "abca",
	"./dr-mario/full6-min.png": "3071",
	"./dr-mario/full7-min.png": "5753",
	"./dr-mario/selected0-min.png": "3d20",
	"./dr-mario/selected1-min.png": "f66b",
	"./dr-mario/selected2-min.png": "7846",
	"./dr-mario/selected3-min.png": "9fb0",
	"./dr-mario/selected4-min.png": "1695",
	"./dr-mario/selected5-min.png": "76d6",
	"./dr-mario/selected6-min.png": "521f",
	"./dr-mario/selected7-min.png": "77d8",
	"./duck-hunt/full0-min.png": "d4d6",
	"./duck-hunt/full1-min.png": "bcdf",
	"./duck-hunt/full2-min.png": "d0a2",
	"./duck-hunt/full3-min.png": "1a63",
	"./duck-hunt/full4-min.png": "ec60",
	"./duck-hunt/full5-min.png": "0dfb",
	"./duck-hunt/full6-min.png": "bd1c",
	"./duck-hunt/full7-min.png": "000f",
	"./duck-hunt/selected0-min.png": "f313",
	"./duck-hunt/selected1-min.png": "eddc",
	"./duck-hunt/selected2-min.png": "17ed",
	"./duck-hunt/selected3-min.png": "4a78",
	"./duck-hunt/selected4-min.png": "f773",
	"./duck-hunt/selected5-min.png": "7f81",
	"./duck-hunt/selected6-min.png": "45a55",
	"./duck-hunt/selected7-min.png": "23cb6",
	"./falco/full0-min.png": "8437",
	"./falco/full1-min.png": "de09",
	"./falco/full2-min.png": "d3b1",
	"./falco/full3-min.png": "2ebc",
	"./falco/full4-min.png": "1b14",
	"./falco/full5-min.png": "3e44",
	"./falco/full6-min.png": "38b9",
	"./falco/full7-min.png": "c1d6",
	"./falco/selected0-min.png": "0deb",
	"./falco/selected1-min.png": "9c24",
	"./falco/selected2-min.png": "e71f",
	"./falco/selected3-min.png": "0f65",
	"./falco/selected4-min.png": "9c47",
	"./falco/selected5-min.png": "4dce",
	"./falco/selected6-min.png": "cdab",
	"./falco/selected7-min.png": "c162",
	"./fox/full0-min.png": "1c49",
	"./fox/full1-min.png": "2594",
	"./fox/full2-min.png": "2078",
	"./fox/full3-min.png": "7768",
	"./fox/full4-min.png": "2e9e",
	"./fox/full5-min.png": "cf4d",
	"./fox/full6-min.png": "9e80",
	"./fox/full7-min.png": "3a82",
	"./fox/selected0-min.png": "4c61",
	"./fox/selected1-min.png": "eef8",
	"./fox/selected2-min.png": "4685",
	"./fox/selected3-min.png": "44ed",
	"./fox/selected4-min.png": "bf43",
	"./fox/selected5-min.png": "5ba4",
	"./fox/selected6-min.png": "8cdc",
	"./fox/selected7-min.png": "91b6",
	"./ganondorf/full0-min.png": "e742",
	"./ganondorf/full1-min.png": "f88f",
	"./ganondorf/full2-min.png": "858b",
	"./ganondorf/full3-min.png": "f8c0",
	"./ganondorf/full4-min.png": "6167",
	"./ganondorf/full5-min.png": "062b",
	"./ganondorf/full6-min.png": "e90f",
	"./ganondorf/full7-min.png": "3cd9",
	"./ganondorf/selected0-min.png": "6dce",
	"./ganondorf/selected1-min.png": "d988",
	"./ganondorf/selected2-min.png": "32f1",
	"./ganondorf/selected3-min.png": "1e34",
	"./ganondorf/selected4-min.png": "692f",
	"./ganondorf/selected5-min.png": "8f94",
	"./ganondorf/selected6-min.png": "9e90",
	"./ganondorf/selected7-min.png": "0e22",
	"./greninja/full0-min.png": "626c",
	"./greninja/full1-min.png": "f245",
	"./greninja/full2-min.png": "80c7",
	"./greninja/full3-min.png": "6ac0",
	"./greninja/full4-min.png": "8281",
	"./greninja/full5-min.png": "3f66",
	"./greninja/full6-min.png": "46aa",
	"./greninja/full7-min.png": "794b",
	"./greninja/selected0-min.png": "f034",
	"./greninja/selected1-min.png": "dc9c",
	"./greninja/selected2-min.png": "a166",
	"./greninja/selected3-min.png": "6746",
	"./greninja/selected4-min.png": "07ae",
	"./greninja/selected5-min.png": "918f",
	"./greninja/selected6-min.png": "0258",
	"./greninja/selected7-min.png": "49b4",
	"./hero/full0-min.png": "75be",
	"./hero/full1-min.png": "ca83",
	"./hero/full2-min.png": "480b",
	"./hero/full3-min.png": "7ec2",
	"./hero/full4-min.png": "abd6",
	"./hero/full5-min.png": "706c",
	"./hero/full6-min.png": "ee59",
	"./hero/full7-min.png": "270e",
	"./hero/selected0-min.png": "ad33",
	"./hero/selected1-min.png": "ff48",
	"./hero/selected2-min.png": "d721",
	"./hero/selected3-min.png": "2903",
	"./hero/selected4-min.png": "656a",
	"./hero/selected5-min.png": "f4da",
	"./hero/selected6-min.png": "a6309",
	"./hero/selected7-min.png": "5818",
	"./ice-climbers/full0-min.png": "8e52",
	"./ice-climbers/full1-min.png": "f848",
	"./ice-climbers/full2-min.png": "1cc6",
	"./ice-climbers/full3-min.png": "c914",
	"./ice-climbers/full4-min.png": "4484",
	"./ice-climbers/full5-min.png": "a85a",
	"./ice-climbers/full6-min.png": "266a",
	"./ice-climbers/full7-min.png": "5979",
	"./ice-climbers/selected0-min.png": "74e5",
	"./ice-climbers/selected1-min.png": "5009",
	"./ice-climbers/selected2-min.png": "2052",
	"./ice-climbers/selected3-min.png": "b2d6",
	"./ice-climbers/selected4-min.png": "8b1c",
	"./ice-climbers/selected5-min.png": "087e",
	"./ice-climbers/selected6-min.png": "0349",
	"./ice-climbers/selected7-min.png": "04ce",
	"./ike/full0-min.png": "c76c",
	"./ike/full1-min.png": "a824",
	"./ike/full2-min.png": "7a50",
	"./ike/full3-min.png": "a719",
	"./ike/full4-min.png": "7c4f",
	"./ike/full5-min.png": "11ff",
	"./ike/full6-min.png": "8bbf",
	"./ike/full7-min.png": "ee84",
	"./ike/selected0-min.png": "9bdde",
	"./ike/selected1-min.png": "b62c",
	"./ike/selected2-min.png": "8292",
	"./ike/selected3-min.png": "fdc4",
	"./ike/selected4-min.png": "0daf",
	"./ike/selected5-min.png": "acec",
	"./ike/selected6-min.png": "1008",
	"./ike/selected7-min.png": "66fc",
	"./incineroar/full0-min.png": "74d3",
	"./incineroar/full1-min.png": "16f9",
	"./incineroar/full2-min.png": "31c6",
	"./incineroar/full3-min.png": "3170",
	"./incineroar/full4-min.png": "91e0",
	"./incineroar/full5-min.png": "c2f6",
	"./incineroar/full6-min.png": "da7f",
	"./incineroar/full7-min.png": "ec8c",
	"./incineroar/selected0-min.png": "9eae",
	"./incineroar/selected1-min.png": "db04",
	"./incineroar/selected2-min.png": "029b",
	"./incineroar/selected3-min.png": "1e18",
	"./incineroar/selected4-min.png": "7918e",
	"./incineroar/selected5-min.png": "1fa6",
	"./incineroar/selected6-min.png": "2a0c",
	"./incineroar/selected7-min.png": "5262",
	"./inkling/full0-min.png": "e72c",
	"./inkling/full1-min.png": "0ef8",
	"./inkling/full2-min.png": "ca6e",
	"./inkling/full3-min.png": "5e47",
	"./inkling/full4-min.png": "4f4b",
	"./inkling/full5-min.png": "216f",
	"./inkling/full6-min.png": "748e",
	"./inkling/full7-min.png": "110e",
	"./inkling/selected0-min.png": "ae83",
	"./inkling/selected1-min.png": "bd0d",
	"./inkling/selected2-min.png": "0e8a",
	"./inkling/selected3-min.png": "a425",
	"./inkling/selected4-min.png": "e3c4",
	"./inkling/selected5-min.png": "3682",
	"./inkling/selected6-min.png": "a1ab",
	"./inkling/selected7-min.png": "4121",
	"./isabelle/full0-min.png": "6020",
	"./isabelle/full1-min.png": "b842",
	"./isabelle/full2-min.png": "55a7",
	"./isabelle/full3-min.png": "79c2",
	"./isabelle/full4-min.png": "6723",
	"./isabelle/full5-min.png": "c639",
	"./isabelle/full6-min.png": "5c2b",
	"./isabelle/full7-min.png": "3f49",
	"./isabelle/selected0-min.png": "80c3",
	"./isabelle/selected1-min.png": "1c50",
	"./isabelle/selected2-min.png": "c9f3",
	"./isabelle/selected3-min.png": "c64e",
	"./isabelle/selected4-min.png": "46b8",
	"./isabelle/selected5-min.png": "8708",
	"./isabelle/selected6-min.png": "dc51",
	"./isabelle/selected7-min.png": "fcac",
	"./jigglypuff/full0-min.png": "1c56",
	"./jigglypuff/full1-min.png": "0600",
	"./jigglypuff/full2-min.png": "d23e",
	"./jigglypuff/full3-min.png": "870c",
	"./jigglypuff/full4-min.png": "1bd0",
	"./jigglypuff/full5-min.png": "f846",
	"./jigglypuff/full6-min.png": "b83c",
	"./jigglypuff/full7-min.png": "22a0",
	"./jigglypuff/selected0-min.png": "e5e5",
	"./jigglypuff/selected1-min.png": "6c80",
	"./jigglypuff/selected2-min.png": "50bd",
	"./jigglypuff/selected3-min.png": "6d67",
	"./jigglypuff/selected4-min.png": "c6a0",
	"./jigglypuff/selected5-min.png": "9c5f",
	"./jigglypuff/selected6-min.png": "d988c",
	"./jigglypuff/selected7-min.png": "4183",
	"./joker/full0-min.png": "c54a",
	"./joker/full1-min.png": "c5ce",
	"./joker/full2-min.png": "82f9",
	"./joker/full3-min.png": "2192",
	"./joker/full4-min.png": "af4f",
	"./joker/full5-min.png": "a8b7",
	"./joker/full6-min.png": "c7fc",
	"./joker/full7-min.png": "032d",
	"./joker/selected0-min.png": "1558",
	"./joker/selected1-min.png": "baff",
	"./joker/selected2-min.png": "ea9b",
	"./joker/selected3-min.png": "ff59",
	"./joker/selected4-min.png": "6e25",
	"./joker/selected5-min.png": "c2d4",
	"./joker/selected6-min.png": "d6ad",
	"./joker/selected7-min.png": "82fb",
	"./kazuya/full0-min.png": "2590",
	"./kazuya/full1-min.png": "6f7f",
	"./kazuya/full2-min.png": "db34",
	"./kazuya/full3-min.png": "f192",
	"./kazuya/full4-min.png": "6b25",
	"./kazuya/full5-min.png": "5db4",
	"./kazuya/full6-min.png": "695d",
	"./kazuya/full7-min.png": "cd17",
	"./kazuya/selected0-min.png": "f4c3",
	"./kazuya/selected1-min.png": "1052",
	"./kazuya/selected2-min.png": "6961",
	"./kazuya/selected3-min.png": "b278",
	"./kazuya/selected4-min.png": "9048",
	"./kazuya/selected5-min.png": "18e9",
	"./kazuya/selected6-min.png": "3c76",
	"./kazuya/selected7-min.png": "910b",
	"./ken/full0-min.png": "d245",
	"./ken/full1-min.png": "93ab",
	"./ken/full2-min.png": "b3dc",
	"./ken/full3-min.png": "512b",
	"./ken/full4-min.png": "f5de",
	"./ken/full5-min.png": "6fa5",
	"./ken/full6-min.png": "6350",
	"./ken/full7-min.png": "c4f7",
	"./ken/selected0-min.png": "537e",
	"./ken/selected1-min.png": "17b0",
	"./ken/selected2-min.png": "7830",
	"./ken/selected3-min.png": "5cbf",
	"./ken/selected4-min.png": "00a9",
	"./ken/selected5-min.png": "680d",
	"./ken/selected6-min.png": "2460",
	"./ken/selected7-min.png": "1c4b",
	"./king-dedede/full0-min.png": "e4d8",
	"./king-dedede/full1-min.png": "be72",
	"./king-dedede/full2-min.png": "a372",
	"./king-dedede/full3-min.png": "4d1ad",
	"./king-dedede/full4-min.png": "f585",
	"./king-dedede/full5-min.png": "98cb",
	"./king-dedede/full6-min.png": "3f9e",
	"./king-dedede/full7-min.png": "af39",
	"./king-dedede/selected0-min.png": "0ea2",
	"./king-dedede/selected1-min.png": "ec49",
	"./king-dedede/selected2-min.png": "5af4",
	"./king-dedede/selected3-min.png": "2d96",
	"./king-dedede/selected4-min.png": "c8d9",
	"./king-dedede/selected5-min.png": "6d2e",
	"./king-dedede/selected6-min.png": "5751",
	"./king-dedede/selected7-min.png": "fb9a",
	"./king-k-rool/full0-min.png": "04c0",
	"./king-k-rool/full1-min.png": "c571",
	"./king-k-rool/full2-min.png": "79d3",
	"./king-k-rool/full3-min.png": "1c50a",
	"./king-k-rool/full4-min.png": "ced6",
	"./king-k-rool/full5-min.png": "b2e9",
	"./king-k-rool/full6-min.png": "fe9b",
	"./king-k-rool/full7-min.png": "f7ca",
	"./king-k-rool/selected0-min.png": "6917",
	"./king-k-rool/selected1-min.png": "2b2d",
	"./king-k-rool/selected2-min.png": "20dd",
	"./king-k-rool/selected3-min.png": "2a37",
	"./king-k-rool/selected4-min.png": "a440",
	"./king-k-rool/selected5-min.png": "6f1b",
	"./king-k-rool/selected6-min.png": "e90d",
	"./king-k-rool/selected7-min.png": "7c64",
	"./kirby/full0-min.png": "eca4",
	"./kirby/full1-min.png": "522a",
	"./kirby/full2-min.png": "944f",
	"./kirby/full3-min.png": "47f1",
	"./kirby/full4-min.png": "76e1",
	"./kirby/full5-min.png": "6ac3",
	"./kirby/full6-min.png": "53d3",
	"./kirby/full7-min.png": "3530",
	"./kirby/selected0-min.png": "00a6",
	"./kirby/selected1-min.png": "8ffe",
	"./kirby/selected2-min.png": "ccec",
	"./kirby/selected3-min.png": "bf90",
	"./kirby/selected4-min.png": "3bd5",
	"./kirby/selected5-min.png": "c4e7",
	"./kirby/selected6-min.png": "9026",
	"./kirby/selected7-min.png": "f5d4",
	"./link/full0-min.png": "04ee",
	"./link/full1-min.png": "f421",
	"./link/full2-min.png": "419a",
	"./link/full3-min.png": "450a",
	"./link/full4-min.png": "5cbf3",
	"./link/full5-min.png": "d7ad",
	"./link/full6-min.png": "a4fd",
	"./link/full7-min.png": "4198",
	"./link/selected0-min.png": "6ce9",
	"./link/selected1-min.png": "3464",
	"./link/selected2-min.png": "fa74",
	"./link/selected3-min.png": "a1b4",
	"./link/selected4-min.png": "e8a9",
	"./link/selected5-min.png": "440b",
	"./link/selected6-min.png": "5baa",
	"./link/selected7-min.png": "71c3",
	"./little-mac/full0-min.png": "3355",
	"./little-mac/full1-min.png": "a935",
	"./little-mac/full2-min.png": "dea4",
	"./little-mac/full3-min.png": "bd62",
	"./little-mac/full4-min.png": "6f52",
	"./little-mac/full5-min.png": "584e",
	"./little-mac/full6-min.png": "e964",
	"./little-mac/full7-min.png": "6a97",
	"./little-mac/selected0-min.png": "6e3a",
	"./little-mac/selected1-min.png": "9ee0a",
	"./little-mac/selected2-min.png": "3c17",
	"./little-mac/selected3-min.png": "61db",
	"./little-mac/selected4-min.png": "a1b41",
	"./little-mac/selected5-min.png": "75e8",
	"./little-mac/selected6-min.png": "f41f",
	"./little-mac/selected7-min.png": "3e8b",
	"./lucario/full0-min.png": "74ad",
	"./lucario/full1-min.png": "3540",
	"./lucario/full2-min.png": "f7ab",
	"./lucario/full3-min.png": "1ca1",
	"./lucario/full4-min.png": "ac34",
	"./lucario/full5-min.png": "96ab",
	"./lucario/full6-min.png": "c6ca",
	"./lucario/full7-min.png": "3e08",
	"./lucario/selected0-min.png": "2a10",
	"./lucario/selected1-min.png": "d21a",
	"./lucario/selected2-min.png": "f0e4",
	"./lucario/selected3-min.png": "6c06",
	"./lucario/selected4-min.png": "bf04",
	"./lucario/selected5-min.png": "f560",
	"./lucario/selected6-min.png": "469c",
	"./lucario/selected7-min.png": "9b73",
	"./lucas/full0-min.png": "7c28",
	"./lucas/full1-min.png": "23fb",
	"./lucas/full2-min.png": "4123",
	"./lucas/full3-min.png": "d42f",
	"./lucas/full4-min.png": "26fd",
	"./lucas/full5-min.png": "f455",
	"./lucas/full6-min.png": "e6a5",
	"./lucas/full7-min.png": "dfb1",
	"./lucas/selected0-min.png": "2f75",
	"./lucas/selected1-min.png": "6223",
	"./lucas/selected2-min.png": "6c84",
	"./lucas/selected3-min.png": "3595",
	"./lucas/selected4-min.png": "8c74",
	"./lucas/selected5-min.png": "e486",
	"./lucas/selected6-min.png": "631e",
	"./lucas/selected7-min.png": "43b4",
	"./lucina/full0-min.png": "17b8",
	"./lucina/full1-min.png": "be32",
	"./lucina/full2-min.png": "2f3a",
	"./lucina/full3-min.png": "d6bb",
	"./lucina/full4-min.png": "b429",
	"./lucina/full5-min.png": "a147",
	"./lucina/full6-min.png": "d2f3",
	"./lucina/full7-min.png": "d0a1",
	"./lucina/selected0-min.png": "874a",
	"./lucina/selected1-min.png": "f568",
	"./lucina/selected2-min.png": "e9df",
	"./lucina/selected3-min.png": "2769",
	"./lucina/selected4-min.png": "333d",
	"./lucina/selected5-min.png": "cc89",
	"./lucina/selected6-min.png": "ac00",
	"./lucina/selected7-min.png": "5584",
	"./luigi/full0-min.png": "4699",
	"./luigi/full1-min.png": "4a3e",
	"./luigi/full2-min.png": "fb36",
	"./luigi/full3-min.png": "ee7b",
	"./luigi/full4-min.png": "c9ea",
	"./luigi/full5-min.png": "2131",
	"./luigi/full6-min.png": "bee1",
	"./luigi/full7-min.png": "0b6a",
	"./luigi/selected0-min.png": "9351",
	"./luigi/selected1-min.png": "08b0",
	"./luigi/selected2-min.png": "c234",
	"./luigi/selected3-min.png": "165c",
	"./luigi/selected4-min.png": "bc17",
	"./luigi/selected5-min.png": "e155",
	"./luigi/selected6-min.png": "b15b",
	"./luigi/selected7-min.png": "9d2e",
	"./mario/full0-min.png": "cde6",
	"./mario/full1-min.png": "81ef",
	"./mario/full2-min.png": "9feb",
	"./mario/full3-min.png": "3368",
	"./mario/full4-min.png": "adf9",
	"./mario/full5-min.png": "3323",
	"./mario/full6-min.png": "ba05",
	"./mario/full7-min.png": "4431",
	"./mario/selected0-min.png": "4fd5",
	"./mario/selected1-min.png": "76db",
	"./mario/selected2-min.png": "af07",
	"./mario/selected3-min.png": "95a7",
	"./mario/selected4-min.png": "6091",
	"./mario/selected5-min.png": "106e",
	"./mario/selected6-min.png": "7a36",
	"./mario/selected7-min.png": "c367",
	"./marth/full0-min.png": "db17",
	"./marth/full1-min.png": "84b3",
	"./marth/full2-min.png": "4092",
	"./marth/full3-min.png": "0033",
	"./marth/full4-min.png": "69bd",
	"./marth/full5-min.png": "67a2",
	"./marth/full6-min.png": "4771",
	"./marth/full7-min.png": "8ce4",
	"./marth/selected0-min.png": "d4c8",
	"./marth/selected1-min.png": "c05e",
	"./marth/selected2-min.png": "32b1",
	"./marth/selected3-min.png": "d05b",
	"./marth/selected4-min.png": "b43e",
	"./marth/selected5-min.png": "a599",
	"./marth/selected6-min.png": "d935",
	"./marth/selected7-min.png": "062e",
	"./mega-man/full0-min.png": "f11f",
	"./mega-man/full1-min.png": "0e35",
	"./mega-man/full2-min.png": "a486",
	"./mega-man/full3-min.png": "1bbe",
	"./mega-man/full4-min.png": "5eea",
	"./mega-man/full5-min.png": "6c94",
	"./mega-man/full6-min.png": "55de",
	"./mega-man/full7-min.png": "af1a",
	"./mega-man/selected0-min.png": "ff7b",
	"./mega-man/selected1-min.png": "1697",
	"./mega-man/selected2-min.png": "043a",
	"./mega-man/selected3-min.png": "8ba7",
	"./mega-man/selected4-min.png": "c561",
	"./mega-man/selected5-min.png": "c350",
	"./mega-man/selected6-min.png": "87f2",
	"./mega-man/selected7-min.png": "3ac3",
	"./meta-knight/full0-min.png": "5ccd",
	"./meta-knight/full1-min.png": "3eb9",
	"./meta-knight/full2-min.png": "61b1",
	"./meta-knight/full3-min.png": "a329",
	"./meta-knight/full4-min.png": "cde1",
	"./meta-knight/full5-min.png": "e48f",
	"./meta-knight/full6-min.png": "f177",
	"./meta-knight/full7-min.png": "6264",
	"./meta-knight/selected0-min.png": "a8d3",
	"./meta-knight/selected1-min.png": "35e5",
	"./meta-knight/selected2-min.png": "c8bf",
	"./meta-knight/selected3-min.png": "e2e4",
	"./meta-knight/selected4-min.png": "66af",
	"./meta-knight/selected5-min.png": "bce0",
	"./meta-knight/selected6-min.png": "63c2",
	"./meta-knight/selected7-min.png": "4e85",
	"./mewtwo/full0-min.png": "2d7a",
	"./mewtwo/full1-min.png": "02bb",
	"./mewtwo/full2-min.png": "ea6a",
	"./mewtwo/full3-min.png": "4805",
	"./mewtwo/full4-min.png": "a0c3",
	"./mewtwo/full5-min.png": "6aa0",
	"./mewtwo/full6-min.png": "93ee",
	"./mewtwo/full7-min.png": "4fa1",
	"./mewtwo/selected0-min.png": "0ccd",
	"./mewtwo/selected1-min.png": "e366",
	"./mewtwo/selected2-min.png": "26be",
	"./mewtwo/selected3-min.png": "4ecd",
	"./mewtwo/selected4-min.png": "17bd",
	"./mewtwo/selected5-min.png": "7f94",
	"./mewtwo/selected6-min.png": "52b1",
	"./mewtwo/selected7-min.png": "1eac",
	"./mii-brawler/full0-min.png": "a076",
	"./mii-brawler/selected0-min.png": "a8f7",
	"./mii-gunner/full0-min.png": "479c",
	"./mii-gunner/selected0-min.png": "c393",
	"./mii-swordfighter/full0-min.png": "ce48",
	"./mii-swordfighter/selected0-min.png": "a9fa",
	"./min-min/full0-min.png": "d6a0",
	"./min-min/full1-min.png": "a57d",
	"./min-min/full2-min.png": "837f",
	"./min-min/full3-min.png": "77f3",
	"./min-min/full4-min.png": "a72c",
	"./min-min/full5-min.png": "ab39",
	"./min-min/full6-min.png": "9d8a",
	"./min-min/full7-min.png": "33a9",
	"./min-min/selected0-min.png": "77cf",
	"./min-min/selected1-min.png": "d6f9",
	"./min-min/selected2-min.png": "bdfa",
	"./min-min/selected3-min.png": "7dec",
	"./min-min/selected4-min.png": "89a1",
	"./min-min/selected5-min.png": "70cd",
	"./min-min/selected6-min.png": "9d94",
	"./min-min/selected7-min.png": "9c67",
	"./mr-game-and-watch/full0-min.png": "0bec",
	"./mr-game-and-watch/full1-min.png": "8f3b",
	"./mr-game-and-watch/full2-min.png": "40c8",
	"./mr-game-and-watch/full3-min.png": "8c6e",
	"./mr-game-and-watch/full4-min.png": "4e2a",
	"./mr-game-and-watch/full5-min.png": "dc40",
	"./mr-game-and-watch/full6-min.png": "7b9a",
	"./mr-game-and-watch/full7-min.png": "4bee",
	"./mr-game-and-watch/selected0-min.png": "f11a",
	"./mr-game-and-watch/selected1-min.png": "4e5d",
	"./mr-game-and-watch/selected2-min.png": "aeaa",
	"./mr-game-and-watch/selected3-min.png": "f1d6",
	"./mr-game-and-watch/selected4-min.png": "13ef",
	"./mr-game-and-watch/selected5-min.png": "9495",
	"./mr-game-and-watch/selected6-min.png": "f98e",
	"./mr-game-and-watch/selected7-min.png": "3ed0",
	"./ness/full0-min.png": "d150",
	"./ness/full1-min.png": "5f39",
	"./ness/full2-min.png": "517a",
	"./ness/full3-min.png": "ba3c",
	"./ness/full4-min.png": "5845",
	"./ness/full5-min.png": "61b3",
	"./ness/full6-min.png": "e1c9",
	"./ness/full7-min.png": "e6fe",
	"./ness/selected0-min.png": "85b7",
	"./ness/selected1-min.png": "31be",
	"./ness/selected2-min.png": "a34f",
	"./ness/selected3-min.png": "fd63",
	"./ness/selected4-min.png": "b32a",
	"./ness/selected5-min.png": "18f7",
	"./ness/selected6-min.png": "1124",
	"./ness/selected7-min.png": "9dae",
	"./olimar/full0-min.png": "02cc",
	"./olimar/full1-min.png": "869c",
	"./olimar/full2-min.png": "77d81",
	"./olimar/full3-min.png": "e380",
	"./olimar/full4-min.png": "2e51",
	"./olimar/full5-min.png": "df12",
	"./olimar/full6-min.png": "9174",
	"./olimar/full7-min.png": "96cb",
	"./olimar/selected0-min.png": "2508",
	"./olimar/selected1-min.png": "839b",
	"./olimar/selected2-min.png": "fd7a",
	"./olimar/selected3-min.png": "ab68",
	"./olimar/selected4-min.png": "b8c5",
	"./olimar/selected5-min.png": "aa78",
	"./olimar/selected6-min.png": "9fdc",
	"./olimar/selected7-min.png": "892e",
	"./pac-man/full0-min.png": "4820",
	"./pac-man/full1-min.png": "c319",
	"./pac-man/full2-min.png": "cdec",
	"./pac-man/full3-min.png": "4530",
	"./pac-man/full4-min.png": "9ffb",
	"./pac-man/full5-min.png": "ad9a",
	"./pac-man/full6-min.png": "d5b5",
	"./pac-man/full7-min.png": "7fb3",
	"./pac-man/selected0-min.png": "d1cb",
	"./pac-man/selected1-min.png": "8c7c",
	"./pac-man/selected2-min.png": "05f2",
	"./pac-man/selected3-min.png": "01c3",
	"./pac-man/selected4-min.png": "a6da",
	"./pac-man/selected5-min.png": "eace",
	"./pac-man/selected6-min.png": "5d6d",
	"./pac-man/selected7-min.png": "5215",
	"./palutena/full0-min.png": "c15f",
	"./palutena/full1-min.png": "0c5b",
	"./palutena/full2-min.png": "68c7",
	"./palutena/full3-min.png": "1b6b",
	"./palutena/full4-min.png": "0f80",
	"./palutena/full5-min.png": "b484",
	"./palutena/full6-min.png": "3aaf",
	"./palutena/full7-min.png": "3c64",
	"./palutena/selected0-min.png": "633c",
	"./palutena/selected1-min.png": "2b69",
	"./palutena/selected2-min.png": "936b",
	"./palutena/selected3-min.png": "55d8",
	"./palutena/selected4-min.png": "24b4",
	"./palutena/selected5-min.png": "27bd",
	"./palutena/selected6-min.png": "14ec",
	"./palutena/selected7-min.png": "f5cd",
	"./peach/full0-min.png": "5a4d",
	"./peach/full1-min.png": "459a",
	"./peach/full2-min.png": "d4f1",
	"./peach/full3-min.png": "0fc8",
	"./peach/full4-min.png": "ac3b",
	"./peach/full5-min.png": "db36",
	"./peach/full6-min.png": "5524",
	"./peach/full7-min.png": "1e04",
	"./peach/selected0-min.png": "e34c",
	"./peach/selected1-min.png": "8a08",
	"./peach/selected2-min.png": "3b30",
	"./peach/selected3-min.png": "c8a8",
	"./peach/selected4-min.png": "7c86",
	"./peach/selected5-min.png": "b290",
	"./peach/selected6-min.png": "de7d",
	"./peach/selected7-min.png": "07fe",
	"./pichu/full0-min.png": "93d5",
	"./pichu/full1-min.png": "200a",
	"./pichu/full2-min.png": "3875",
	"./pichu/full3-min.png": "e2a3",
	"./pichu/full4-min.png": "b34b",
	"./pichu/full5-min.png": "416c",
	"./pichu/full6-min.png": "8318",
	"./pichu/full7-min.png": "7a92",
	"./pichu/selected0-min.png": "002b",
	"./pichu/selected1-min.png": "305b",
	"./pichu/selected2-min.png": "234a",
	"./pichu/selected3-min.png": "e4b1",
	"./pichu/selected4-min.png": "4153",
	"./pichu/selected5-min.png": "ac23",
	"./pichu/selected6-min.png": "8ff9",
	"./pichu/selected7-min.png": "b7e4",
	"./pikachu/full0-min.png": "e4fc",
	"./pikachu/full1-min.png": "069a",
	"./pikachu/full2-min.png": "6225",
	"./pikachu/full3-min.png": "8155",
	"./pikachu/full4-min.png": "7cb6",
	"./pikachu/full5-min.png": "5b06",
	"./pikachu/full6-min.png": "25f0a",
	"./pikachu/full7-min.png": "e5db",
	"./pikachu/selected0-min.png": "45e4",
	"./pikachu/selected1-min.png": "002b6",
	"./pikachu/selected2-min.png": "d395",
	"./pikachu/selected3-min.png": "2b46",
	"./pikachu/selected4-min.png": "c4a6",
	"./pikachu/selected5-min.png": "2972",
	"./pikachu/selected6-min.png": "2e04",
	"./pikachu/selected7-min.png": "6d88",
	"./piranha-plant/full0-min.png": "ac36",
	"./piranha-plant/full1-min.png": "a8ac",
	"./piranha-plant/full2-min.png": "6bc8",
	"./piranha-plant/full3-min.png": "d587",
	"./piranha-plant/full4-min.png": "78af",
	"./piranha-plant/full5-min.png": "6d99",
	"./piranha-plant/full6-min.png": "4793",
	"./piranha-plant/full7-min.png": "c9e7",
	"./piranha-plant/selected0-min.png": "e984",
	"./piranha-plant/selected1-min.png": "b86d",
	"./piranha-plant/selected2-min.png": "5853",
	"./piranha-plant/selected3-min.png": "a15c",
	"./piranha-plant/selected4-min.png": "3505",
	"./piranha-plant/selected5-min.png": "de74",
	"./piranha-plant/selected6-min.png": "7229",
	"./piranha-plant/selected7-min.png": "fdfe",
	"./pit/full0-min.png": "a6ed",
	"./pit/full1-min.png": "8cb0",
	"./pit/full2-min.png": "4bbf",
	"./pit/full3-min.png": "73c3",
	"./pit/full4-min.png": "278d",
	"./pit/full5-min.png": "80f3",
	"./pit/full6-min.png": "76b0",
	"./pit/full7-min.png": "042a",
	"./pit/selected0-min.png": "1bbd",
	"./pit/selected1-min.png": "14c5",
	"./pit/selected2-min.png": "7b27",
	"./pit/selected3-min.png": "4237",
	"./pit/selected4-min.png": "05df",
	"./pit/selected5-min.png": "afcc",
	"./pit/selected6-min.png": "b6eb",
	"./pit/selected7-min.png": "cbea",
	"./pokemon-trainer/full0-min.png": "9c1d",
	"./pokemon-trainer/full1-min.png": "e457",
	"./pokemon-trainer/full2-min.png": "5afe",
	"./pokemon-trainer/full3-min.png": "37a1",
	"./pokemon-trainer/full4-min.png": "1093",
	"./pokemon-trainer/full5-min.png": "340f",
	"./pokemon-trainer/full6-min.png": "4ab3",
	"./pokemon-trainer/full7-min.png": "5ce3",
	"./pokemon-trainer/selected0-min.png": "d3a8",
	"./pokemon-trainer/selected1-min.png": "cefb",
	"./pokemon-trainer/selected2-min.png": "ade3",
	"./pokemon-trainer/selected3-min.png": "a38d",
	"./pokemon-trainer/selected4-min.png": "0e1f",
	"./pokemon-trainer/selected5-min.png": "28ed",
	"./pokemon-trainer/selected6-min.png": "8daf",
	"./pokemon-trainer/selected7-min.png": "b9b8",
	"./pyra-and-mythra/full0-min.png": "cf87",
	"./pyra-and-mythra/full1-min.png": "1419",
	"./pyra-and-mythra/full2-min.png": "8770",
	"./pyra-and-mythra/full3-min.png": "a2e1",
	"./pyra-and-mythra/full4-min.png": "5a2d",
	"./pyra-and-mythra/full5-min.png": "61d0",
	"./pyra-and-mythra/full6-min.png": "8e1e",
	"./pyra-and-mythra/full7-min.png": "e74e",
	"./pyra-and-mythra/selected0-min.png": "029e",
	"./pyra-and-mythra/selected1-min.png": "0c62",
	"./pyra-and-mythra/selected2-min.png": "a0be",
	"./pyra-and-mythra/selected3-min.png": "784e",
	"./pyra-and-mythra/selected4-min.png": "b125",
	"./pyra-and-mythra/selected5-min.png": "ec76",
	"./pyra-and-mythra/selected6-min.png": "05c8",
	"./pyra-and-mythra/selected7-min.png": "d8ce",
	"./richter/full0-min.png": "161d",
	"./richter/full1-min.png": "7806",
	"./richter/full2-min.png": "c04a",
	"./richter/full3-min.png": "2bd1",
	"./richter/full4-min.png": "6387",
	"./richter/full5-min.png": "1ba8",
	"./richter/full6-min.png": "89b7",
	"./richter/full7-min.png": "cc3e",
	"./richter/selected0-min.png": "b829",
	"./richter/selected1-min.png": "b743",
	"./richter/selected2-min.png": "71ed",
	"./richter/selected3-min.png": "9977",
	"./richter/selected4-min.png": "edb2",
	"./richter/selected5-min.png": "f15c",
	"./richter/selected6-min.png": "6011",
	"./richter/selected7-min.png": "9a0e",
	"./ridley/full0-min.png": "ea26",
	"./ridley/full1-min.png": "a74d",
	"./ridley/full2-min.png": "230d",
	"./ridley/full3-min.png": "e98c",
	"./ridley/full4-min.png": "31b8",
	"./ridley/full5-min.png": "dd2f",
	"./ridley/full6-min.png": "fa1f",
	"./ridley/full7-min.png": "6f77",
	"./ridley/selected0-min.png": "8b8c",
	"./ridley/selected1-min.png": "fc0b",
	"./ridley/selected2-min.png": "b55c",
	"./ridley/selected3-min.png": "e0cc",
	"./ridley/selected4-min.png": "9a01",
	"./ridley/selected5-min.png": "7c76",
	"./ridley/selected6-min.png": "ed3c",
	"./ridley/selected7-min.png": "70aa",
	"./rob/full0-min.png": "c22d",
	"./rob/full1-min.png": "59c3",
	"./rob/full2-min.png": "d6dc",
	"./rob/full3-min.png": "131f",
	"./rob/full4-min.png": "0517",
	"./rob/full5-min.png": "6316",
	"./rob/full6-min.png": "728b",
	"./rob/full7-min.png": "8caa",
	"./rob/selected0-min.png": "c946",
	"./rob/selected1-min.png": "5ba5",
	"./rob/selected2-min.png": "263a",
	"./rob/selected3-min.png": "7c865",
	"./rob/selected4-min.png": "fe66",
	"./rob/selected5-min.png": "0494",
	"./rob/selected6-min.png": "c5d6",
	"./rob/selected7-min.png": "c572",
	"./robin/full0-min.png": "ed7f",
	"./robin/full1-min.png": "b151",
	"./robin/full2-min.png": "6e79",
	"./robin/full3-min.png": "a539",
	"./robin/full4-min.png": "663c",
	"./robin/full5-min.png": "0355",
	"./robin/full6-min.png": "fd86",
	"./robin/full7-min.png": "cb0e",
	"./robin/selected0-min.png": "134f",
	"./robin/selected1-min.png": "14fd",
	"./robin/selected2-min.png": "f7c3",
	"./robin/selected3-min.png": "6114",
	"./robin/selected4-min.png": "c675",
	"./robin/selected5-min.png": "a239",
	"./robin/selected6-min.png": "be97",
	"./robin/selected7-min.png": "e1ae",
	"./rosalina-and-luma/full0-min.png": "a94e",
	"./rosalina-and-luma/full1-min.png": "06e5",
	"./rosalina-and-luma/full2-min.png": "3aa3",
	"./rosalina-and-luma/full3-min.png": "e9d1",
	"./rosalina-and-luma/full4-min.png": "ca48",
	"./rosalina-and-luma/full5-min.png": "de9d",
	"./rosalina-and-luma/full6-min.png": "e597",
	"./rosalina-and-luma/full7-min.png": "527c",
	"./rosalina-and-luma/selected0-min.png": "e5e50",
	"./rosalina-and-luma/selected1-min.png": "906b",
	"./rosalina-and-luma/selected2-min.png": "dc74",
	"./rosalina-and-luma/selected3-min.png": "0084",
	"./rosalina-and-luma/selected4-min.png": "e1bb",
	"./rosalina-and-luma/selected5-min.png": "bc20",
	"./rosalina-and-luma/selected6-min.png": "38ce",
	"./rosalina-and-luma/selected7-min.png": "be2e",
	"./roy/full0-min.png": "31d0",
	"./roy/full1-min.png": "b686",
	"./roy/full2-min.png": "1b2b",
	"./roy/full3-min.png": "5a24",
	"./roy/full4-min.png": "22ec",
	"./roy/full5-min.png": "f216",
	"./roy/full6-min.png": "fa83",
	"./roy/full7-min.png": "e4b2",
	"./roy/selected0-min.png": "15c7",
	"./roy/selected1-min.png": "4025",
	"./roy/selected2-min.png": "2943",
	"./roy/selected3-min.png": "d16c",
	"./roy/selected4-min.png": "70d9",
	"./roy/selected5-min.png": "96a7",
	"./roy/selected6-min.png": "6718",
	"./roy/selected7-min.png": "a419",
	"./ryu/full0-min.png": "7850",
	"./ryu/full1-min.png": "803f",
	"./ryu/full2-min.png": "d8fa",
	"./ryu/full3-min.png": "3bae",
	"./ryu/full4-min.png": "5d8c",
	"./ryu/full5-min.png": "29d6",
	"./ryu/full6-min.png": "a2a4",
	"./ryu/full7-min.png": "bb66",
	"./ryu/selected0-min.png": "d813",
	"./ryu/selected1-min.png": "c782",
	"./ryu/selected2-min.png": "ae9a",
	"./ryu/selected3-min.png": "9416",
	"./ryu/selected4-min.png": "be47",
	"./ryu/selected5-min.png": "c52d",
	"./ryu/selected6-min.png": "6118",
	"./ryu/selected7-min.png": "0e74",
	"./samus/full0-min.png": "6d19",
	"./samus/full1-min.png": "4a8a",
	"./samus/full2-min.png": "6604",
	"./samus/full3-min.png": "3744",
	"./samus/full4-min.png": "a1e9",
	"./samus/full5-min.png": "37b0",
	"./samus/full6-min.png": "fef1",
	"./samus/full7-min.png": "a1f0",
	"./samus/selected0-min.png": "6e42",
	"./samus/selected1-min.png": "74b2",
	"./samus/selected2-min.png": "cb57",
	"./samus/selected3-min.png": "b299",
	"./samus/selected4-min.png": "2da5",
	"./samus/selected5-min.png": "1b1b",
	"./samus/selected6-min.png": "1844",
	"./samus/selected7-min.png": "341e",
	"./sephiroth/full0-min.png": "5143",
	"./sephiroth/full1-min.png": "60d6",
	"./sephiroth/full2-min.png": "b7a5",
	"./sephiroth/full3-min.png": "c4fa",
	"./sephiroth/full4-min.png": "d515",
	"./sephiroth/full5-min.png": "9166",
	"./sephiroth/full6-min.png": "b323",
	"./sephiroth/full7-min.png": "5a50",
	"./sephiroth/selected0-min.png": "f10d",
	"./sephiroth/selected1-min.png": "b1e1",
	"./sephiroth/selected2-min.png": "7db3",
	"./sephiroth/selected3-min.png": "d77e",
	"./sephiroth/selected4-min.png": "9c18",
	"./sephiroth/selected5-min.png": "59fa",
	"./sephiroth/selected6-min.png": "6522",
	"./sephiroth/selected7-min.png": "ff99",
	"./sheik/full0-min.png": "f031",
	"./sheik/full1-min.png": "e89d",
	"./sheik/full2-min.png": "2fc5",
	"./sheik/full3-min.png": "d154",
	"./sheik/full4-min.png": "f99d",
	"./sheik/full5-min.png": "7e30",
	"./sheik/full6-min.png": "94e0",
	"./sheik/full7-min.png": "61d7",
	"./sheik/selected0-min.png": "3fe3",
	"./sheik/selected1-min.png": "41d9",
	"./sheik/selected2-min.png": "71a0",
	"./sheik/selected3-min.png": "b8c58",
	"./sheik/selected4-min.png": "1eb4",
	"./sheik/selected5-min.png": "315b",
	"./sheik/selected6-min.png": "69b5",
	"./sheik/selected7-min.png": "4eb8",
	"./shulk/full0-min.png": "183f",
	"./shulk/full1-min.png": "42cd",
	"./shulk/full2-min.png": "2303",
	"./shulk/full3-min.png": "8ea0",
	"./shulk/full4-min.png": "2bba",
	"./shulk/full5-min.png": "02ef",
	"./shulk/full6-min.png": "7789",
	"./shulk/full7-min.png": "9a62",
	"./shulk/selected0-min.png": "9b9b",
	"./shulk/selected1-min.png": "0921",
	"./shulk/selected2-min.png": "2523",
	"./shulk/selected3-min.png": "8586",
	"./shulk/selected4-min.png": "b1be",
	"./shulk/selected5-min.png": "ad93",
	"./shulk/selected6-min.png": "d629",
	"./shulk/selected7-min.png": "c698",
	"./simon/full0-min.png": "edcb",
	"./simon/full1-min.png": "ecfe",
	"./simon/full2-min.png": "e7be",
	"./simon/full3-min.png": "a8ac1",
	"./simon/full4-min.png": "a678",
	"./simon/full5-min.png": "0e5e",
	"./simon/full6-min.png": "af35",
	"./simon/full7-min.png": "a909",
	"./simon/selected0-min.png": "3852",
	"./simon/selected1-min.png": "13a3",
	"./simon/selected2-min.png": "1bd00",
	"./simon/selected3-min.png": "17fd",
	"./simon/selected4-min.png": "9fb08",
	"./simon/selected5-min.png": "fe3e",
	"./simon/selected6-min.png": "aa53",
	"./simon/selected7-min.png": "106c",
	"./snake/full0-min.png": "a9e6",
	"./snake/full1-min.png": "8357",
	"./snake/full2-min.png": "8007",
	"./snake/full3-min.png": "5e2d",
	"./snake/full4-min.png": "ccfb",
	"./snake/full5-min.png": "a44f",
	"./snake/full6-min.png": "4035",
	"./snake/full7-min.png": "fa0f",
	"./snake/selected0-min.png": "d547",
	"./snake/selected1-min.png": "eb58",
	"./snake/selected2-min.png": "3d89",
	"./snake/selected3-min.png": "a32f",
	"./snake/selected4-min.png": "a74f",
	"./snake/selected5-min.png": "f92e",
	"./snake/selected6-min.png": "9432",
	"./snake/selected7-min.png": "5123",
	"./sonic/full0-min.png": "8dd0",
	"./sonic/full1-min.png": "f875",
	"./sonic/full2-min.png": "366b",
	"./sonic/full3-min.png": "9d62",
	"./sonic/full4-min.png": "7397",
	"./sonic/full5-min.png": "4a6f",
	"./sonic/full6-min.png": "0859",
	"./sonic/full7-min.png": "0d89",
	"./sonic/selected0-min.png": "9b02",
	"./sonic/selected1-min.png": "0c47",
	"./sonic/selected2-min.png": "9a06",
	"./sonic/selected3-min.png": "0236",
	"./sonic/selected4-min.png": "7a2f",
	"./sonic/selected5-min.png": "9754",
	"./sonic/selected6-min.png": "21d0",
	"./sonic/selected7-min.png": "8fc7",
	"./sora/full0-min.png": "9271",
	"./sora/full1-min.png": "f221",
	"./sora/full2-min.png": "0d26",
	"./sora/full3-min.png": "9013",
	"./sora/full4-min.png": "129a",
	"./sora/full5-min.png": "bc53",
	"./sora/full6-min.png": "cc22",
	"./sora/full7-min.png": "0f4e",
	"./sora/selected0-min.png": "28c3",
	"./sora/selected1-min.png": "354f",
	"./sora/selected2-min.png": "7315",
	"./sora/selected3-min.png": "88b5",
	"./sora/selected4-min.png": "ed7e",
	"./sora/selected5-min.png": "43c9",
	"./sora/selected6-min.png": "4d0e",
	"./sora/selected7-min.png": "0423",
	"./steve/full0-min.png": "1a32",
	"./steve/full1-min.png": "f999",
	"./steve/full2-min.png": "1843",
	"./steve/full3-min.png": "e36d",
	"./steve/full4-min.png": "3b95",
	"./steve/full5-min.png": "288d",
	"./steve/full6-min.png": "7349",
	"./steve/full7-min.png": "0cbe",
	"./steve/selected0-min.png": "b338",
	"./steve/selected1-min.png": "3457",
	"./steve/selected2-min.png": "021b",
	"./steve/selected3-min.png": "74fe",
	"./steve/selected4-min.png": "66d1",
	"./steve/selected5-min.png": "8597",
	"./steve/selected6-min.png": "9181",
	"./steve/selected7-min.png": "3eed",
	"./terry/full0-min.png": "6bc2",
	"./terry/full1-min.png": "6a06",
	"./terry/full2-min.png": "e26e",
	"./terry/full3-min.png": "f23d",
	"./terry/full4-min.png": "bb27",
	"./terry/full5-min.png": "f670",
	"./terry/full6-min.png": "a7ec",
	"./terry/full7-min.png": "96c5",
	"./terry/selected0-min.png": "24c7",
	"./terry/selected1-min.png": "a3bc",
	"./terry/selected2-min.png": "c4b7",
	"./terry/selected3-min.png": "1084",
	"./terry/selected4-min.png": "d609",
	"./terry/selected5-min.png": "7af7",
	"./terry/selected6-min.png": "d392",
	"./terry/selected7-min.png": "0c6f",
	"./toon-link/full0-min.png": "e0eb",
	"./toon-link/full1-min.png": "87c9",
	"./toon-link/full2-min.png": "6591",
	"./toon-link/full3-min.png": "fcd5",
	"./toon-link/full4-min.png": "0b38",
	"./toon-link/full5-min.png": "80a8",
	"./toon-link/full6-min.png": "361f",
	"./toon-link/full7-min.png": "bbb4",
	"./toon-link/selected0-min.png": "4ce1",
	"./toon-link/selected1-min.png": "8ce9",
	"./toon-link/selected2-min.png": "e4e1",
	"./toon-link/selected3-min.png": "a07d",
	"./toon-link/selected4-min.png": "6fd6",
	"./toon-link/selected5-min.png": "8a12",
	"./toon-link/selected6-min.png": "4d5e",
	"./toon-link/selected7-min.png": "85dd",
	"./villager/full0-min.png": "9405",
	"./villager/full1-min.png": "86e8",
	"./villager/full2-min.png": "344f",
	"./villager/full3-min.png": "1ef6",
	"./villager/full4-min.png": "ed40",
	"./villager/full5-min.png": "cfdd",
	"./villager/full6-min.png": "01227",
	"./villager/full7-min.png": "99fa",
	"./villager/selected0-min.png": "d338",
	"./villager/selected1-min.png": "6f14",
	"./villager/selected2-min.png": "3a8f",
	"./villager/selected3-min.png": "e2a3c",
	"./villager/selected4-min.png": "bf0b",
	"./villager/selected5-min.png": "9e38",
	"./villager/selected6-min.png": "346a",
	"./villager/selected7-min.png": "d6c8",
	"./wario/full0-min.png": "b811",
	"./wario/full1-min.png": "af03",
	"./wario/full2-min.png": "6d35",
	"./wario/full3-min.png": "e8aa",
	"./wario/full4-min.png": "617e",
	"./wario/full5-min.png": "096f",
	"./wario/full6-min.png": "93fe",
	"./wario/full7-min.png": "eb73",
	"./wario/selected0-min.png": "79a8",
	"./wario/selected1-min.png": "b932",
	"./wario/selected2-min.png": "45fd",
	"./wario/selected3-min.png": "42ba",
	"./wario/selected4-min.png": "1732",
	"./wario/selected5-min.png": "c5fe",
	"./wario/selected6-min.png": "8283",
	"./wario/selected7-min.png": "5e18",
	"./wii-fit-trainer/full0-min.png": "85a2",
	"./wii-fit-trainer/full1-min.png": "1e17",
	"./wii-fit-trainer/full2-min.png": "454b",
	"./wii-fit-trainer/full3-min.png": "7c9c",
	"./wii-fit-trainer/full4-min.png": "d60c",
	"./wii-fit-trainer/full5-min.png": "4939",
	"./wii-fit-trainer/full6-min.png": "209a",
	"./wii-fit-trainer/full7-min.png": "899c",
	"./wii-fit-trainer/selected0-min.png": "6f9e",
	"./wii-fit-trainer/selected1-min.png": "d0ae",
	"./wii-fit-trainer/selected2-min.png": "f184",
	"./wii-fit-trainer/selected3-min.png": "3ac9",
	"./wii-fit-trainer/selected4-min.png": "69e9",
	"./wii-fit-trainer/selected5-min.png": "0ae2",
	"./wii-fit-trainer/selected6-min.png": "c9df",
	"./wii-fit-trainer/selected7-min.png": "a7fb",
	"./wolf/full0-min.png": "a9d2",
	"./wolf/full1-min.png": "5453",
	"./wolf/full2-min.png": "1a3c",
	"./wolf/full3-min.png": "9259",
	"./wolf/full4-min.png": "2af8",
	"./wolf/full5-min.png": "76c4",
	"./wolf/full6-min.png": "0450",
	"./wolf/full7-min.png": "d3f0",
	"./wolf/selected0-min.png": "3c70",
	"./wolf/selected1-min.png": "a4f8",
	"./wolf/selected2-min.png": "ec3b",
	"./wolf/selected3-min.png": "28f5",
	"./wolf/selected4-min.png": "0c72",
	"./wolf/selected5-min.png": "04b6",
	"./wolf/selected6-min.png": "1044",
	"./wolf/selected7-min.png": "4a9d",
	"./yoshi/full0-min.png": "10fd",
	"./yoshi/full1-min.png": "f7c0",
	"./yoshi/full2-min.png": "25db",
	"./yoshi/full3-min.png": "5aa5",
	"./yoshi/full4-min.png": "2f4d",
	"./yoshi/full5-min.png": "9d0d",
	"./yoshi/full6-min.png": "b8e9",
	"./yoshi/full7-min.png": "c424",
	"./yoshi/selected0-min.png": "91f8",
	"./yoshi/selected1-min.png": "8458",
	"./yoshi/selected2-min.png": "ac09",
	"./yoshi/selected3-min.png": "80d3",
	"./yoshi/selected4-min.png": "eb34",
	"./yoshi/selected5-min.png": "4903",
	"./yoshi/selected6-min.png": "5b4d",
	"./yoshi/selected7-min.png": "e83d",
	"./young-link/full0-min.png": "c593",
	"./young-link/full1-min.png": "3642",
	"./young-link/full2-min.png": "4491",
	"./young-link/full3-min.png": "6d68",
	"./young-link/full4-min.png": "2040",
	"./young-link/full5-min.png": "5ba1",
	"./young-link/full6-min.png": "5637",
	"./young-link/full7-min.png": "4655",
	"./young-link/selected0-min.png": "bcef",
	"./young-link/selected1-min.png": "3733",
	"./young-link/selected2-min.png": "a5dd",
	"./young-link/selected3-min.png": "2c53",
	"./young-link/selected4-min.png": "5e0c",
	"./young-link/selected5-min.png": "36b1",
	"./young-link/selected6-min.png": "f25a",
	"./young-link/selected7-min.png": "d1500",
	"./zelda/full0-min.png": "1a19",
	"./zelda/full1-min.png": "0409",
	"./zelda/full2-min.png": "9a9d",
	"./zelda/full3-min.png": "43f8",
	"./zelda/full4-min.png": "66a3",
	"./zelda/full5-min.png": "b362",
	"./zelda/full6-min.png": "12e2",
	"./zelda/full7-min.png": "f014",
	"./zelda/selected0-min.png": "4854",
	"./zelda/selected1-min.png": "55c9",
	"./zelda/selected2-min.png": "f61c",
	"./zelda/selected3-min.png": "420c",
	"./zelda/selected4-min.png": "2583",
	"./zelda/selected5-min.png": "2ee2",
	"./zelda/selected6-min.png": "d482",
	"./zelda/selected7-min.png": "44de",
	"./zero-suit-samus/full0-min.png": "66aa",
	"./zero-suit-samus/full1-min.png": "fe74",
	"./zero-suit-samus/full2-min.png": "ef02",
	"./zero-suit-samus/full3-min.png": "4341",
	"./zero-suit-samus/full4-min.png": "88b2",
	"./zero-suit-samus/full5-min.png": "8c02",
	"./zero-suit-samus/full6-min.png": "417e",
	"./zero-suit-samus/full7-min.png": "90d0",
	"./zero-suit-samus/selected0-min.png": "51ae",
	"./zero-suit-samus/selected1-min.png": "b009",
	"./zero-suit-samus/selected2-min.png": "8795",
	"./zero-suit-samus/selected3-min.png": "0032",
	"./zero-suit-samus/selected4-min.png": "58d8",
	"./zero-suit-samus/selected5-min.png": "f2c7",
	"./zero-suit-samus/selected6-min.png": "b31d",
	"./zero-suit-samus/selected7-min.png": "d42d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b5d";